export default __webpack_public_path__ + "static/media/LeftArrow.d3e1f13d.svg";